// Stable per-device identity used for one-account-per-person enforcement.
const KEY = 'ee_did';

const readCookie = (n) => (document.cookie.split('; ').find(c => c.startsWith(`${n}=`)) || '').split('=')[1] || '';

const rnd = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`);

export const getDeviceId = () => {
    let id = '';
    try { id = localStorage.getItem(KEY) || ''; } catch (_) { /* ignore */ }
    if (!id) id = readCookie(KEY);
    if (!id) id = rnd();
    try { localStorage.setItem(KEY, id); } catch (_) { /* ignore */ }
    document.cookie = `${KEY}=${id}; path=/; max-age=${60 * 60 * 24 * 730}; SameSite=Lax; Secure`;
    return id;
};

const hash = (str) => {
    let h1 = 0xdeadbeef, h2 = 0x41c6ce57;
    for (let i = 0; i < str.length; i++) {
        const ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
    return (h2 >>> 0).toString(16).padStart(8, '0') + (h1 >>> 0).toString(16).padStart(8, '0');
};

const canvasSig = () => {
    try {
        const c = document.createElement('canvas');
        c.width = 240; c.height = 60;
        const x = c.getContext('2d');
        x.textBaseline = 'top'; x.font = "16px 'Arial'"; x.fillStyle = '#f60'; x.fillRect(100, 1, 62, 20);
        x.fillStyle = '#069'; x.fillText('EagleEyes ₹ 💎 ꧁', 2, 15);
        x.fillStyle = 'rgba(102,204,0,0.7)'; x.fillText('EagleEyes ₹ 💎 ꧁', 4, 17);
        return c.toDataURL();
    } catch (_) { return ''; }
};

const webglSig = () => {
    try {
        const gl = document.createElement('canvas').getContext('webgl');
        const ext = gl && gl.getExtension('WEBGL_debug_renderer_info');
        return ext ? `${gl.getParameter(ext.UNMASKED_VENDOR_WEBGL)}~${gl.getParameter(ext.UNMASKED_RENDERER_WEBGL)}` : '';
    } catch (_) { return ''; }
};

const MODEL_KEY = 'ee_dmodel';
export const getDeviceModel = () => {
    let m = '';
    try { m = localStorage.getItem(MODEL_KEY) || ''; } catch (_) { /* ignore */ }
    const uad = navigator.userAgentData;
    if (!m && uad && uad.getHighEntropyValues) {
        uad.getHighEntropyValues(['model']).then(v => {
            if (v.model) { try { localStorage.setItem(MODEL_KEY, v.model); } catch (_) { /* ignore */ } }
        }).catch(() => {});
    }
    return m;
};

let fpCache = '';
export const getFingerprint = () => {
    if (fpCache) return fpCache;
    const n = navigator;
    const parts = [
        n.platform, n.hardwareConcurrency, n.deviceMemory, n.maxTouchPoints,
        `${window.screen.width}x${window.screen.height}x${window.screen.colorDepth}`, window.devicePixelRatio,
        Intl.DateTimeFormat().resolvedOptions().timeZone, (n.languages || []).join(','),
        webglSig(), canvasSig(),
    ];
    fpCache = hash(parts.join('|'));
    return fpCache;
};
